/**
 * `RX-007`: "Binocular PD is derived and displayed. Storing only binocular PD loses information
 * needed for progressive lenses."
 *
 * Derived rather than stored, so an asymmetric face cannot be flattened into one number and then
 * split evenly again when a progressive is ordered.
 */
export function binocularPd(measurement) {
    return measurement.monocularPdOd + measurement.monocularPdOs;
}
//# sourceMappingURL=fitting.js.map